import alignedPlan from './src/alignedPlan.vue'

export default alignedPlan
